import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'  
import setImg from '@/assets/scripts/utils/setImg';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import animated from 'animate.css'
import ScrollLoader from 'vue-scroll-loader';
import BaiduMap from 'vue-baidu-map'
import '@/assets/scripts/permission';

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'DUzIocXbWgOTpsnxv0EglF6L1p2yhxu3'
})
Vue.config.productionTip = false; 

Vue.prototype.$setImg = setImg;
Vue.use(VueDOMPurifyHTML)
Vue.use(ScrollLoader)
Vue.use(animated) 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
